import React from 'react';
import PropTypes from 'prop-types';

import './Breadcrumbs.sass';

import {FormattedMessage} from 'react-intl';

import ChannelLink from '../../containers/channelUtils/ChannelLink';

export default function Breadcrumbs({links = []}) {
  return (
    <div className="breadcrumbs">
      <span className="breadcrumbs__item">
        <ChannelLink to="/" className="breadcrumbs__link">
          <FormattedMessage id="section.breadcrumbs.home"/>
        </ChannelLink>
      </span>
      {links.map(({name, to}, idx) => (
        <span
          key={idx} className="breadcrumbs__item"
        >
          {to ? (
            <ChannelLink to={to} className="breadcrumbs__link">{name}</ChannelLink>
          ) : (
            name
          )}
        </span>
      ))}
    </div>
  );
}

Breadcrumbs.propTypes = {
  links: PropTypes.array
};



// WEBPACK FOOTER //
// ./components/breadcrumbs/Breadcrumbs.js